import React from "react";
import { Container, MapContainer } from "./MapPageStyle";
import Seo from "../../components/Seo";
import requiredAuth from "../../components/requiredAuth";
import { useTranslation } from "react-i18next";
import GeoMap from "../../components/Map/GeoMap";

function GeoMapPage() {
  const { t, i18n } = useTranslation();

  return (
    <Container>
      <Seo title={t(`monitoring`)} />
      <MapContainer>
        <GeoMap />
      </MapContainer>
    </Container>
  );
}
export default requiredAuth(GeoMapPage);
